// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5KBfZ","label":"styles_label__3oupE"};